import { useTranslation } from 'react-i18next';
import { Button, Icon, useTheme } from '../../../../../base-components';
import { useFormContext } from 'react-hook-form';
import { ITableForm, TableFormValues } from '../../../../../../common';

const TopRightActions = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { setValue, watch } = useFormContext<ITableForm>();
    const filters = watch(TableFormValues.filters);

    const handleClearAll = () => {
        setValue(TableFormValues.filters, []);
    };

    return (
        <Button
            variant="text"
            onClick={handleClearAll}
            style={{
                marginTop: theme.spacing(2),
                marginInlineEnd: theme.spacing(3),
                color:
                    filters.length === 0
                        ? theme.palette.grey[300]
                        : theme.palette.grey[600],
            }}
            disabled={filters.length === 0}
        >
            <Icon
                name={'SmallCloseIcon'}
                size={15}
                color={
                    filters.length === 0
                        ? theme.palette.grey[300]
                        : theme.palette.error.main
                }
            />
            {t('filters.clearAll')}
        </Button>
    );
};

export default TopRightActions;
